import { ButtonIcon, Modal } from '../../../../components';
import React, { useState } from 'react';
import { ModalFooter } from '../../../../components/modal/Modal';
import { GLOBAL_ICONS, QUERIES_IDS } from '../../../../util/vars';
import { CancelButtonModal, ConfirmButtonModal } from '../../../../global';
import { useI18n } from '@whizz/react-i18n';
import ReactDatePicker from 'react-datepicker';
import { useMutation, useQueryClient } from 'react-query';
import { repository } from '@whizz/api-client';
import { DateTime } from 'luxon';

export default function ChangePausedUntilModal({ toggle, schools, onSuccess }: Props) {
  const { translate: t } = useI18n();
  const queryClient = useQueryClient();

  const [ pausedUntil, setPausedUntil ] = useState<Date | null>(null);

  const putWeeklyLeadersEmailPausedUntilMutation = useMutation({
    mutationFn: () => repository.AdminRepository.putSchoolWeeklyLeadersEmailPausedUntil(schools, DateTime.fromJSDate(pausedUntil!)),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [ QUERIES_IDS.ADMIN.GET_SCHOOLS ], exact: false });
      onSuccess();
      toggle();
    },
  });

  function NextSendDateInput() {
    return (
      <ReactDatePicker
        id={'next_send_date'}
        className={'inline w-28'}
        onChange={(date) => setPausedUntil(date)}
        selected={pausedUntil}
        dateFormat={'dd/MM/YYYY'}
      />
    );
  }

  return (
    <Modal
      open
      toggle={() => toggle()}
      onClose={() => toggle()}
    >
      <div className={'container flex items-center pb-md border-b-2 border-header'}>
        <div className="flex items-center">
          <h5 className={'font-bold'}>
            Change Next Send Date
          </h5>
        </div>
        <div className={'ml-auto'}>
          <ButtonIcon
            icon={GLOBAL_ICONS.close}
            onClick={() => toggle()}
            size={'sm'}
            color={'light'}
            isOutline
            isCircle
          />
        </div>
      </div>

      <div className={'container flex flex-col gap-5'}>
        <p>
          This will change the next send date for {schools.length} schools whose emails are enabled.
        </p>
        <p>
          Their next email for each school will be sent on or after <NextSendDateInput /> depending on the day of the week it is configured to be sent.
        </p>
      </div>

      <ModalFooter>
        <CancelButtonModal
          disabled={putWeeklyLeadersEmailPausedUntilMutation.isLoading}
          onClick={() => toggle()}
        >
          {t('components.BUTTONS.CANCEL')}
        </CancelButtonModal>
        <ConfirmButtonModal
          disabled={null === pausedUntil || putWeeklyLeadersEmailPausedUntilMutation.isLoading}
          onClick={() => putWeeklyLeadersEmailPausedUntilMutation.mutate()}
        >
          {t('components.BUTTONS.CONFIRM2')}
        </ConfirmButtonModal>
      </ModalFooter>
    </Modal>
  );
}


interface Props {
  toggle: () => void;
  schools: number[];
  onSuccess: () => void;
}
